(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var LABEL = 'Buy It Now';

  function build() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 't4s-buy-now__btn';
    b.setAttribute('data-buy-now', '');
    b.innerHTML = '<span class="t4s-buy-now__label">' + LABEL + '</span><span class="t4s-buy-now__spinner" aria-hidden="true"></span>';
    return b;
  }

  function inject(wrap) {
    if (!wrap || wrap.querySelector('[data-buy-now]')) return;
    var form = wrap.closest('form');
    if (!form || form.classList.contains('is--atc-sticky')) return;
    var atc = wrap.querySelector('button[name="add"]');
    if (!atc || atc.hasAttribute('disabled')) return;
    var row = atc.closest('.t4s-d-flex');
    var btn = build();
    if (row && row.parentNode) { row.parentNode.insertBefore(btn, row.nextSibling); }
    else { atc.parentNode.appendChild(btn); }
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('.t4s-product-form__buttons');
    for (var i = 0; i < list.length; i++) { inject(list[i]); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-buy-now]') : null;
    if (!btn || btn.classList.contains('is--loading')) return;
    e.preventDefault();
    e.stopPropagation();
    var form = btn.closest('form');
    if (!form) return;
    btn.classList.add('is--loading');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.classList.remove('is--loading');
          alert((res.data && (res.data.description || res.data.message)) || 'Sorry, this item could not be added.');
          return;
        }
        window.location.href = ROOT + 'checkout';
      })
      .catch(function () {
        btn.classList.remove('is--loading');
        form.submit();
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('t4s-product-form__buttons')) { inject(n); }
          else { scan(n); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
